export default __webpack_public_path__ + "static/tabs-hierarchy-dont-4fb094a5ffc5b75494b695fe07dfb8ad.png";